import { use as fegoUse } from '@fegobull/webapi';

const { useBehaviour } = fegoUse;
const { runBehaviour } = useBehaviour();

export function toLogin(): void {
  runBehaviour(null, {
    type: 'login',
    value: location.href,
    withQuery: true,
  });
}

export function toLink(url: string): void {
  if (!url) {
    return;
  }
  runBehaviour(null, {
    value: url,
    type: 'link',
    withQuery: true,
  });
}

/** HK 入金页，可由编辑器覆盖。 */
export const DEFAULT_DEPOSIT_URL = 'https://funds.futuhk.com/deposit';

export const DEFAULT_PRIZE_URL = 'https://www.futunn.com/activity/prize';
